module.exports = __webpack_public_path__ + "static/img/3.b13ebec5.png";